import React, { Component } from "react";
import { currentLocals } from "../../languages/languages.js";
import "../../styles/Conversion.css";
import { WithFlags } from "@lectra/ld-react-feature-flags";

import { ViewIcon, ValidIcon, ErrorIcon } from "@lectra/mui-library-icons";

import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CircularProgress from "@mui/material/CircularProgress";
import { Tooltip } from "@mui/material";

export default class Conversion extends Component {
  constructor(props) {
    super(props);
    this.handleGetMDLData = this.handleGetMDLData.bind(this);
    this.handleDownLoadMDL = this.handleDownLoadMDL.bind(this);
    this.handleShowMDLInPatternAssistant = this.handleShowMDLInPatternAssistant.bind(this);
  }

  handleGetMDLData(event, dataout, datain, id) {
    let element = event.target;
    if (element.classList.contains("BuildingDataView")) return;

    let bopenMDLViewer =
      element.getAttribute("bopenmdlviewer") === "undefined" ? true : element.getAttribute("bopenmdlviewer");
    const { getMDLData } = this.props;
    getMDLData({ dataout, datain, id, bopenMDLViewer });
  }

  handleDownLoadMDL(event, dataout, datain, id) {
    let download = document.getElementById("DownLoad_" + this.props.id);
    download.classList.remove("download");
    download.classList.add("downloading");

    const { downLoadMDL } = this.props;
    downLoadMDL({ dataout, datain, id });
  }
  handleShowMDLInPatternAssistant(event, dataout, datain, id) {
    const { showMDLInPatternAssistant } = this.props;
    showMDLInPatternAssistant({ dataout, datain, id });
  }
  render() {
    const extension = this.props.datain.split(".").pop();
    const filename = this.props.datain.replace("." + extension, "");
    const viewchrono = this.props.viewchrono ? "visible" : "hidden";
    const displyadownloadmdl = this.props.enabledownload ? "" : "none";

    ///////////
    var sConverterInfo;
    var sConvertertype;
    let converters = this.props.converters;
    const arrow = "  \u{1F8A7}  ";
    var currentConverter;

    for (let i = 0; i < converters.length; i++) {
      if (converters[i].id === this.props.converter) {
        //Encontrado
        currentConverter = converters[i];
        if (
          currentConverter.type === "accumark" ||
          currentConverter.type === "aama_astm" ||
          currentConverter.typeInOut === "In"
        ) {
          sConverterInfo = " " + converters[i].type + arrow + "mdl";
          sConvertertype = currentConverter.type;
        } else if (currentConverter.type === "mdl" || currentConverter.typeInOut === "Out") {
          sConverterInfo = " mdl" + arrow + converters[i].typeDestination + "";
          sConvertertype = currentConverter.typeDestination;
        }
      }
    }
    ///////////
    const renderDataout = () => {
      if (this.props.status === "Done") {
        return <div className="task dataoutDone">{this.props.dataout} </div>;
      } else if (this.props.status === "ko") return <div className="task dataoutKo">{this.props.dataout} </div>;
      else return <div className="task dataoutSend">{this.props.dataout} </div>;
    };
    const renderStatus = () => {
      if (this.props.status === "ko") {
        return (
          <div
            conversionid={this.props.id}
            id={`status_${filename}_${this.props.id}`}
            className={`task status ${this.props.status}`}
          >
            <ErrorIcon style={{ color: "#E73D20" }}></ErrorIcon>&nbsp;&nbsp;
            {currentLocals(this.props.locale).conversion[this.props.status]}
            {renderToolTipdescription()}
          </div>
        );
      } else if (this.props.status === "Sent" || this.props.status === "in_convertion") {
        return (
          <div
            conversionid={this.props.id}
            id={`status_${filename}_${this.props.id}`}
            className={`task status ${this.props.status}`}
          >
            <CircularProgress size="1.3rem" style={{ color: "#16A085" }}></CircularProgress>&nbsp;&nbsp;
            {currentLocals(this.props.locale).conversion[this.props.status]}
            {renderToolTipdescription()}
          </div>
        );
      } else if (this.props.status === "Done") {
        return (
          <div
            conversionid={this.props.id}
            id={`status_${filename}_${this.props.id}`}
            className={`task status ${this.props.status}`}
          >
            <ValidIcon style={{ color: "#2ECC71" }}></ValidIcon>&nbsp;&nbsp;
            {currentLocals(this.props.locale).conversion[this.props.status]}
            {renderToolTipdescription()}
          </div>
        );
      } else if (this.props.status === "Error_on_CAD_Data_send" || this.props.status === "TimeOut") {
        return (
          <div
            conversionid={this.props.id}
            id={`status_${filename}_${this.props.id}`}
            className={`task status ${this.props.status}`}
          >
            <ErrorIcon style={{ color: "#E73D20" }}></ErrorIcon>&nbsp;&nbsp;
            {currentLocals(this.props.locale).conversion[this.props.status]}
            {renderToolTipdescription()}
          </div>
        );
      }
    };
    const renderToolTipdescription = () => {
      if (this.props.status === "ko") {
        return (
          <span className={`task  tooltiptext`}>
            {" "}
            {currentLocals(this.props.locale).conversion[this.props.description]}
          </span>
        );
      }
    };
    const renderViewer = () => {};

    let VisibilityEye;

    if (this.props.type === "mdl") VisibilityEye = "hidden";
    else {
      if (this.props.status === "Done") VisibilityEye = "visible";
      else VisibilityEye = "hidden";
    }

    //const VisibilityEye = this.props.status === "Done" ? "visible" : "hidden";

    const HViewerStandard = () => (
      <div
        id={`View_${this.props.id}`}
        className="task View w3-spin"
        style={{ visibility: VisibilityEye }}
        onClick={(event) => {
          this.handleGetMDLData(event, this.props.dataout, this.props.datain, this.props.id);
        }}
      ></div>
    );
    const HViewerPatternsAssistant = () => (
      <div
        id={`ViewPatternAssistant_${this.props.id}`}
        className="task ViewPatternAssistant w3-spin"
        style={{ visibility: VisibilityEye }}
        onClick={(event) => {
          this.handleShowMDLInPatternAssistant(event, this.props.dataout, this.props.datain, this.props.id);
        }}
      ></div>
    );

    const HhViewerFeatureFlipped = WithFlags("viewPatternAssistant")(HViewerPatternsAssistant, HViewerStandard);

    let bas = 0;
    return (
      <div id={`conversion${this.props.id}`} className={`job-container ${this.props.type}`}>
        <div className="task-container">
          <div className="task eraselist"></div>
          <div className="task date">{this.props.date}</div>
          <div className="task datain">{this.props.datain}</div>
          {/* <div className="task dataout">{this.props.dataout} </div>*/}
          {renderDataout()}
          <div className={`task converter ${sConvertertype}`}>{currentConverter.id}</div>
          <div className={`task conversion ${sConvertertype}`}>
            <div className={`square ${sConvertertype}`}></div>
            &nbsp;&nbsp;
            <div>{sConverterInfo.toUpperCase()}</div>
          </div>
          {renderStatus()}
          <Tooltip title={currentLocals(this.props.locale).conversion.ViewPatternAssistant}>
            <ViewIcon
              style={{ color: "#0000008A", visibility: VisibilityEye }}
              id={`ViewPatternAssistant_${this.props.id}`}
              className="task ViewPatternAssistant"
              onClick={(event) => {
                this.handleShowMDLInPatternAssistant(event, this.props.dataout, this.props.datain, this.props.id);
              }}
            ></ViewIcon>
          </Tooltip>
          <Tooltip title={currentLocals(this.props.locale).conversion.Download}>
            <CloudDownloadIcon
              id={`DownLoad_${this.props.id}`}
              className="task download"
              font-size="17px"
              style={{ color: "#0000008A", visibility: "hidden", display: displyadownloadmdl }}
              onClick={(event) => {
                this.handleDownLoadMDL(event, this.props.dataout, this.props.datain, this.props.id);
              }}
            ></CloudDownloadIcon>
          </Tooltip>
          {/*
            <div
              id={`DownLoad_${this.props.id}`}
              className="task download"
              style={{ visibility: "hidden", display: displyadownloadmdl }}
              onClick={(event) => {
                this.handleDownLoadMDL(event, this.props.dataout, this.props.datain, this.props.id);
              }}
            ></div>

            */}
          <a id={`urimdl_${this.props.id}`} target="_blank"></a>
        </div>
        {/*</div>*/}
      </div>
    );
  }
}
